<template>
  <div>
    <component
      :is="layout"
      v-if="layout"
      :update-available="updateAvailable"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import AppLayout from './layouts/AppLayout';
import AuthLayout from './layouts/AuthLayout';
import { SplashScreen } from '@capacitor/splash-screen';
import { mapGetters } from 'vuex';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import '@mdi/font/css/materialdesignicons.css';
import './scss/main.scss';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading);

export default {
  components: {
    app: AppLayout,
    auth: AuthLayout
  },

  metaInfo () {
    const appName = process.env.VUE_APP_NAME;

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    };
  },

  data: () => ({
    layout: null,
    defaultLayout: 'app',
    layouts: ['app', 'auth'],
    worker: null,
    updateAvailable: false
  }),

  computed: mapGetters({
    isLoggedIn: 'auth/check'
  }),

  watch: {
    isLoggedIn (v) {
      if (v) {
        this.startSync();
      }
    }
  },

  mounted () {
    Vue.prototype.setLayout = this.setLayout;

    defineCustomElements(window);

    window.addEventListener('application_update', () => {
      this.updateAvailable = true;
    });

    this.worker = new Worker('./workers/sync.worker.js', { type: 'module' });
    this.worker.onmessage = (_) => {
      // console.log(event);
    };

    window.addEventListener('online', () => {
      this.worker.postMessage({ type: 'networkOnline' });
    });

    window.addEventListener('offline', () => {
      this.worker.postMessage({ type: 'networkOffline' });
    });

    Vue.prototype.$syncWorker = this.worker;

    if (this.isLoggedIn) {
      this.startSync();
    }

    const user = this.$store.getters['auth/user'];
    if (user && user.id) {
      this.$store.dispatch('auth/fetchUser');
    }
  },

  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout (layout) {
      if (!this.layout) {
        this.$nextTick(() => {
          SplashScreen.hide();
        });
      }

      if (!layout || this.layouts.indexOf(layout) === -1) {
        layout = this.defaultLayout;
      }

      this.layout = layout;
    },

    startSync () {
      console.info('Try worker script definition');
      if (this.worker && this.isLoggedIn) {
        // this.worker.postMessage({ type: 'setDbType', dbType: (global.isWeb) ? null : 'cordova-sqlite' });
        if (!global.isWeb && window.localStorage.getItem('instanceURL')) {
          this.worker.postMessage({ type: 'baseURLChange', url: window.localStorage.getItem('instanceURL') });
        }
        this.worker.postMessage({ type: 'startSync', accessToken: this.$store.getters['auth/token'] });

        console.info('DEFINE WATCHERS');
        setTimeout(() => {
          this.$pouch.changes({
            since: 'now',
            live: true,
            include_docs: true
          }, 'projects').on('change', (change) => {
            console.info('PROJECT CHANGE');
            this.worker.postMessage({ type: 'projectChange', change });
          });

          this.$pouch.changes({
            since: 'now',
            live: true,
            include_docs: true
          }, 'project_data').on('change', (change) => {
            console.info('PROJECT DATA CHANGE');
            this.worker.postMessage({ type: 'projectDataChange', change });
          }, 5000);
        })
      }
    }
  }
};
</script>
